"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@material-ui/core/styles");
const package_1 = require("../package");
const styles = (theme) => (0, styles_1.createStyles)({
    content: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: theme.palette.secondary.main,
        borderStyle: 'solid',
        borderWidth: 1,
        backgroundColor: theme.palette.common.black,
        borderRadius: theme.spacing(),
        padding: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        maxWidth: 400
    },
    icon: {
        fontSize: 40,
        color: theme.palette.error.main,
        marginRight: theme.spacing(2)
    }
});
const ArcadeNotification = ({ classes, children }) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.content }, { children: [(0, jsx_runtime_1.jsx)(package_1.Icon, { iconName: 'warning', iconType: 'material', className: classes.icon }), children] })));
exports.default = (0, styles_1.withStyles)(styles)(ArcadeNotification);
//# sourceMappingURL=ArcadeNotification.js.map